import { useAuthStore } from "@app/stores/useAuthStore.ts";
import { useEnterpriseStore } from "@app/stores/useEnterpriseStore.ts";
import { trpc } from "@app/trpc.ts";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

export function useCurrentEnterpriseId() {
  const userId = useAuthStore((store) => store.user?.id);
  const currentEnterpriseId = useEnterpriseStore((store) =>
    store.currentEnterpriseUserId === userId ? store.currentEnterpriseId : null,
  );
  const setCurrentEnterpriseId = useEnterpriseStore(
    (store) => store.setCurrentEnterpriseId,
  );
  const enterprisesQuery = useQuery({
    ...trpc.enterprises.list.queryOptions(),
    enabled: !!userId && !currentEnterpriseId,
  });
  const enterpriseId =
    currentEnterpriseId ?? enterprisesQuery.data?.[0]?.id ?? null;

  useEffect(() => {
    if (!enterpriseId || !userId || currentEnterpriseId) {
      return;
    }

    setCurrentEnterpriseId(enterpriseId, userId);
  }, [currentEnterpriseId, enterpriseId, setCurrentEnterpriseId, userId]);

  return {
    enterpriseId,
    isLoading: !!userId && !enterpriseId && enterprisesQuery.isLoading,
  };
}
